/**
 * GlobalAuth `admin: users` — one account with every linked sign-in method.
 * The users service keeps only some of them in its card (an email linked later
 * doesn't show up there), so the card asks GlobalAuth for the full list.
 * `id` is the GlobalAuth UUID — the users card's `globalauth_id`.
 */
import { useQuery } from '@tanstack/react-query';
import { apiOg } from './client';
export function useGaUser(id) {
    return useQuery({
        queryKey: ['og', 'ga-user', id],
        queryFn: () => apiOg('auth', `/admin/users/${encodeURIComponent(id ?? '')}`),
        enabled: !!id,
        retry: false,
    });
}
